import React from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Avatar,
  Typography,
  Button,
  Grid
} from '@mui/material';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

export default function LightingModePreview({ data, onClose }) {

  if (!data) return null;

  const { name, description, ...rest } = data;

  const chartData = [];

  for (let i = 1; i <= 6; i++) {
    if (rest[`validT${i}`]) {

      const startSec =
        Number(rest[`sH${i}`]) * 3600 +
        Number(rest[`sM${i}`]) * 60 +
        Number(rest[`sS${i}`]);

      const endSec =
        Number(rest[`eH${i}`]) * 3600 +
        Number(rest[`eM${i}`]) * 60 +
        Number(rest[`eS${i}`]);

      chartData.push({ timeSec: startSec, brightness: rest[`sbri${i}`] });
      chartData.push({ timeSec: endSec, brightness: rest[`ebri${i}`] });
    }
  }

  chartData.sort((a, b) => a.timeSec - b.timeSec);

  const formatSec = (sec) => {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{ padding: 20 }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 900, width: '100%', backgroundColor: '#00122E', color: '#fff' }}>

          <CardHeader
            avatar={<Avatar>{name?.[0]}</Avatar>}
            title={name}
            subheader={description}
          />

          <CardContent>

            <Typography variant="h6" sx={{ mb: 2 }}>
              Power over time %
            </Typography>

            <div style={{ width: '100%', height: 300 }}>
              <ResponsiveContainer>
                <LineChart data={chartData}>
                  <CartesianGrid stroke="#444" strokeDasharray="3 3" />
                  <XAxis dataKey="timeSec" tickFormatter={formatSec} />
                  <YAxis stroke="#fff" />
                  <Tooltip labelFormatter={formatSec} />
                  <Line type="stepAfter" dataKey="brightness" stroke="#ffeb3b" />
                </LineChart>
              </ResponsiveContainer>
            </div>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={onClose}>
                Close
              </Button>
            </Box>

          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}